
import axios from 'axios'

export default {
  getBudgets: (page = 1, pagination = true, filters = {}) => axios.get('/budgets', { params: { page: page, pagination: pagination, ...filters } }),
  getBudget: budgetId => axios.get(`/budgets/${budgetId}`),
  postBudget: (budget) => axios.post('/budgets', budget),
  putBudget: (budgetId, updatedBudget) => axios.put(`/budgets/${budgetId}`, updatedBudget),
  putUserBudgetsUser: (memberId, updatedInfo) => axios.put(`/user_budgets/${memberId}`, updatedInfo),
  archiveBudget: (budgetId) => axios.delete(`/budgets/${budgetId}`)
}
